import { TieupListGetInputModel } from "./GetInputModel"
import { TieupListGetResponse } from "./getResponse"
import { httpGet } from "../../../../libs/http/httpGet"

export const getTieupList = (
  model: TieupListGetInputModel,
): Promise<TieupListGetResponse> => {
  return httpGet<TieupListGetResponse>(`/v1/tieup/list`, model)
}
